export enum ErrorCodesEnum {
    AccountAlreadyConfirmed = <any>'AccountAlreadyConfirmed',
    AccountError = <any>'AccountError'
}
